module.exports = __webpack_public_path__ + "img/logo.096d6de1.png";